// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Target only this table's horizontal scrollbar */
.custom-scrollbar-table .ant-table-body::-webkit-scrollbar {
  height: 6px; /* 👈 smaller height for horizontal scrollbar */
}

.custom-scrollbar-table .ant-table-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.custom-scrollbar-table .ant-table-body::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 4px;
}

/* Optional for Firefox */
.custom-scrollbar-table .ant-table-body {
  scrollbar-width: thin;
  scrollbar-color: #999 #f1f1f1;
}

.custom-content {
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.h-100 {
  height: 100vh;
  overflow: hidden;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,kDAAkD;AAClD;EACE,WAAW,EAAE,+CAA+C;AAC9D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Target only this table's horizontal scrollbar */\n.custom-scrollbar-table .ant-table-body::-webkit-scrollbar {\n  height: 6px; /* 👈 smaller height for horizontal scrollbar */\n}\n\n.custom-scrollbar-table .ant-table-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.custom-scrollbar-table .ant-table-body::-webkit-scrollbar-thumb {\n  background-color: #999;\n  border-radius: 4px;\n}\n\n/* Optional for Firefox */\n.custom-scrollbar-table .ant-table-body {\n  scrollbar-width: thin;\n  scrollbar-color: #999 #f1f1f1;\n}\n\n.custom-content {\n  height: 100vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.h-100 {\n  height: 100vh;\n  overflow: hidden;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
